import React from 'react';

const Plus = () => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13">
    <g id="Icon_feather-plus" data-name="Icon feather-plus" transform="translate(1.5 1.5)">
      <path id="Path_1663" data-name="Path 1663" d="M18,7.5v10" transform="translate(-13 -7.5)" fill="none" stroke="#ec1c24" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
      <path id="Path_1664" data-name="Path 1664" d="M7.5,18h10" transform="translate(-7.5 -13)" fill="none" stroke="#ec1c24" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
    </g>
    </svg>
  );
};

export default Plus;